import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getCartTesterProducts } from "@src/store/slices/checkoutBlocks/selectors";
import {
  openProductPicker,
  setProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const openCartTesterProductPicker = createAsyncThunk<void, string>(
  "productPicker/openCartTesterProductPicker",
  (variationId, { dispatch, getState }) => {
    dispatch(openProductPicker({ type: "cartTester", variationId }));

    const cartTesterProducts = getCartTesterProducts(variationId)(getState());

    if (cartTesterProducts.length === 0) {
      dispatch(setProductPickerSelectedProducts([]));
      return;
    }

    const productMap = new Map<string, ProductPickerSelectedProduct>();

    cartTesterProducts.forEach((product) => {
      const existing = productMap.get(product.id);

      if (existing) {
        const combinedVariantIds = [
          ...(existing.selectedVariantIds || []),
          product.variantId,
        ];
        existing.selectedVariantIds = [...new Set(combinedVariantIds)];
      } else {
        productMap.set(product.id, {
          id: product.id,
          title: product.title,
          image: product.image,
          handle: "",
          requiresSellingPlan: undefined,
          selectedVariantIds: [product.variantId],
        });
      }
    });

    dispatch(setProductPickerSelectedProducts(Array.from(productMap.values())));
  }
);
